import React, {useState, useEffect} from "react";

import type {SelectProps} from 'antd';
import { Select } from "antd";
import GovPlatformApi from "../../api/GovPlatformApi";
import type { GovPlatform } from "../../type/GovPlatformType";
import { ProFormSelectProps } from "@ant-design/pro-form/lib/components/Select";
import { ProFormSelect } from "@ant-design/pro-form";

const GovPlatformSelector:React.FC<ProFormSelectProps> = (props)=>{

    const [options, setOptions] = useState<[]>([]);

    useEffect(()=>{
        GovPlatformApi.findGovPlatformList({
            limit: 100,
            deletedFlag: false,
        }).then((result:any)=>{
            const newOptions = result.map((govPlatform:GovPlatform)=>{
                return {
                    key: govPlatform.id,
                    value: govPlatform.id,
                    label: govPlatform.platformName,
                };
            });

            setOptions(newOptions);
        });
    }, []);

    return (
        <ProFormSelect
            options={options}
            {...props}
        />
    );
};

export default GovPlatformSelector;